module.exports = __webpack_public_path__ + "img/button_5.2f02b87f.png";